import { render } from "./ProvenanceReviewView.vue?vue&type=template&id=f3846fda&scoped=true"
import script from "./ProvenanceReviewView.vue?vue&type=script&lang=js"
export * from "./ProvenanceReviewView.vue?vue&type=script&lang=js"

import "./ProvenanceReviewView.vue?vue&type=style&index=0&id=f3846fda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3846fda"]])

export default __exports__